<template>
  <div class="prompts">
    <div class="prompts-item">
      <img class="roster-clear-img" src="./plaint.svg" alt="" />
      <slot> </slot>
    </div>
    <div class="prompts-item1">
      <slot name="two"> </slot>
    </div>
    <!-- <blank height="8"> </blank> -->
  </div>
</template>

<script>
// 插槽组件 蓝底提示栏  一行直接使用  两行用具名插槽'two' 两行是要添加8px 的下空行
export default {
  props: {}
}
</script>

<style lang='scss' scoped>
.prompts {
  color: rgba(230, 247, 255, 1);
  background-color: rgba(230, 247, 255, 1);
  box-shadow: rgba(186, 231, 255, 1) solid 1px;
  border-radius: 4px;

  .prompts-item {
    // height: 35px;
    line-height: 35px;
    margin-left: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    text-align: left;
    .roster-clear-img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
  .prompts-item1 {
    margin-left: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    text-align: left;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/prompts/index.vue